import * as React from 'react';
import styled from '@emotion/styled';
import { Button, Modal, tokens } from '@hotjar/hotsauce';
import { AddOrganizationForm } from '@hotjar/webapp/features/Settings/SitesAndOrganizations/AddOrganization/AddOrganizationForm';
import { useAddOrganizationMutation } from '@hotjar/webapp/features/Settings/SitesAndOrganizations/AddOrganization/useAddOrganizationMutation';
import { useTranslation } from 'react-i18next';

const ModalForm = styled.div`
  margin-top: ${tokens.spacer.x3};
  > form {
    > div {
      width: 100%;
    }
  }
`;

export const CreateOrgModal = ({
  isOpen,
  setModalState,
  onCreated,
}: {
  isOpen: boolean;
  setModalState: (isOpen: boolean) => void;
  onCreated: (orgId: number) => void;
}): JSX.Element => {
  const { mutation } = useAddOrganizationMutation(onCreated);
  const { t } = useTranslation('account');

  return (
    <Modal
      appElementSelector="#root"
      isOpen={isOpen}
      onClose={() => {
        setModalState(false);
      }}
      contentLabel={t('create-site.create-org.title')}
    >
      <Modal.Header title={t('create-site.create-org.title')} />
      <Modal.Body>
        {t('create-site.create-org.body')}
        <ModalForm>
          <AddOrganizationForm addOrganization={(name) => mutation.mutate(name)} />
        </ModalForm>
      </Modal.Body>
      <Modal.Footer>
        <Button kind="ghost" onClick={() => setModalState(false)}>
          {t('create-site.create-org.cancel')}
        </Button>
        <Button form="create-org-form" type="submit" isLoading={mutation.isLoading}>
          {t('create-site.create-org.submit')}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};
